import UpdateMarkerScorecard from './scorecard-marker-update.js';

export default class ToggleScorecard {
	constructor($scorecard) {
		this.$scorecard = $scorecard;
		this.$status = 

		// init events
		this.init();
	}

	/**
	 * Initializes the event handlers
	 */

	init() {
		this.$toggleButton = this.$scorecard.find('.c-score__follow--toggle');
		this.$toggleButton.on('click', () => {
			this.toggleScorecardDetails(this.$scorecard);
		});

		this.$updateMarker = this.$scorecard.find('.js-form-update-marker-scorecard');

		if (this.$updateMarker.length) {
			new UpdateMarkerScorecard(this.$scorecard);
		}
		
	}

	toggleScorecardDetails() {
		this.$scorecardDetail = this.$scorecard.find('.c-score__details');
		// show or hide the scorecard-details
		if (this.$scorecardDetail.is(':visible')) {
			this.$scorecard.removeClass('c-score--open');
			this.$scorecardDetail.hide();
		} else {
			this.$scorecard.addClass('c-score--open');
			this.$scorecardDetail.show();
		}
	}
}